import React, { Component } from "react";

class TextBoxGray extends Component {
  render() {
    return (
      <div className="uk-padding-small uk-background-muted uk-margin-bottom">
        <div className="uk-padding-small">
          {this.props.subheading && (
            <h4 className="uk-heading-divider uk-margin-remove-bottom">{this.props.subheading}</h4>
          )}
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default TextBoxGray;
